enum CompetitiveInsightsManageProjectStatusEnum {
  Active = "Active",
  Inactive = "Inactive",
}

export { CompetitiveInsightsManageProjectStatusEnum };
